export var compKey = 'floating-notification';
//# sourceMappingURL=key.js.map